import React from "react";
import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import { ReactComponent as EmailIcon } from "../../assets/email__icon.svg";
import { ReactComponent as CloseBtn } from "../../assets/modal_close.svg";

export const CONTACT_EMAIL = "contact@bluepoint.ac";

interface Props {
  /** entry: 화면 진입 시 안내, submit: 제출 버튼 클릭 시 안내 */
  variant: "entry" | "submit";
  close: () => void;
}

const ServerNoticeModal: React.FC<Props> = (props) => {
  const mode = DisplayType();
  const { t } = useLanguage();
  const message = t("modal", `serverNotice.${props.variant}.detailDesktop`);
  return (
    <Container>
      <ContentsContainer>
        {mode !== "Mobile" && (
          <CloseBtn className="close__btn" onClick={props.close} />
        )}
        <EmailIcon width={56} height={56} />
        <div
          className={`server__notice__title ${
            mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
          }`}
        >
          {t("modal", `serverNotice.${props.variant}.title`)}
        </div>
        {mode === "Mobile" ? (
          <p className="server__notice__content font-body4">
            {renderText(
              t("modal", `serverNotice.${props.variant}.detailMobile`)
            )}
          </p>
        ) : (
          <pre className="server__notice__content font-body2">{message}</pre>
        )}
        <a
          className={`server__notice__email ${
            mode === "Mobile" ? "font-sub-title4" : "font-sub-title3"
          }`}
          href={`mailto:${CONTACT_EMAIL}`}
        >
          {CONTACT_EMAIL}
        </a>
      </ContentsContainer>
      {mode === "Mobile" && (
        <div className="mobile__close" onClick={props.close}>
          {t("modal", "serverNotice.button")}
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .mobile__close {
    width: 100%;
    height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-00);
    color: var(--primary);
  }
`;

const ContentsContainer = styled.div`
  position: relative;
  width: 1060px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 80px;

  .close__btn {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 0.2s ease-in;
    border-radius: 8px;
    :hover {
      background-color: var(--grey-00);
    }
  }

  .server__notice__title {
    text-align: center;
    color: var(--grey-60);
  }
  .server__notice__content {
    text-align: center;
    color: var(--grey-40);
  }
  .server__notice__email {
    color: var(--primary);
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }

  @media only screen and (max-width: 768px) {
    width: calc(100vw - 64px);
    padding: 40px 24px;
    gap: 24px;

    .server__notice__content {
      text-align: start;
      width: 100%;
    }
  }
`;

export default React.memo(ServerNoticeModal);
